import { createTheme } from '@mui/material/styles';

export const lightFinanceTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#C9A800',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#0099BB',
        },
        success: {
            main: '#00916A',
        },
        error: {
            main: '#D32F2F',
        },
        background: {
            default: '#F7F7FB',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#0D0D1A',
            secondary: 'rgba(13,13,26,0.6)',
        },
    },
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#F7F7FB',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0,0,0,0.03)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0,0,0,0.18)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0,153,187,0.6)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#0099BB',
                        borderWidth: '1.5px',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D32F2F',
                    },
                },
                input: {
                    color: '#0D0D1A',
                    '&::placeholder': {
                        color: 'rgba(13,13,26,0.35)',
                        opacity: 1,
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'rgba(13,13,26,0.55)',
                    fontSize: '0.875rem',
                    '&.Mui-focused': {
                        color: '#0099BB',
                    },
                    '&.Mui-error': {
                        color: '#D32F2F',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    backgroundColor: '#C9A800',
                    color: '#FFFFFF',
                    fontWeight: 700,
                    letterSpacing: '0.5px',
                    '&:hover': {
                        backgroundColor: '#B39500',
                        boxShadow: '0 0 24px rgba(201,168,0,0.3)',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: 'rgba(201,168,0,0.3)',
                        color: 'rgba(255,255,255,0.6)',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'rgba(13,13,26,0.5)',
                    '&:hover': {
                        color: '#0099BB',
                        backgroundColor: 'rgba(0,153,187,0.08)',
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        color: '#D32F2F',
                    },
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: 'rgba(13,13,26,0.08)',
                    fontSize: '0.82rem',
                },
                head: {
                    backgroundColor: 'rgba(201,168,0,0.07)',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:last-child td, &:last-child th': {
                        borderBottom: 0,
                    },
                },
            },
        },
    },
});
